import { Observable } from "rxjs/Observable"
import { Map } from "immutable"

import {
    CLUSTER_LIST_REQUEST,
    CLUSTER_LIST_SEARCH_REQUEST,
    CLUSTER_APPLY_FILTER_CRITERIA,
    CLUSTER_ITEM_REQUEST,
    CLUSTER_LIST_RESPONSE,
    CLUSTER_ITEM_RESPONSE,
    CLUSTER_ITEM_CACHED_RESPONSE,
    CLUSTER_CANCEL_MODEL_UPDATE,
    CLUSTER_ITEM_SAVE_REQUEST,
    CLUSTER_ITEM_SAVE_RESPONSE,
    CLUSTER_ITEM_DELETE_REQUEST,
    CLUSTER_ITEM_DELETE_RESPONSE,
    CLUSTER_APPLY_MODEL_UPDATE,
    CLUSTER_MODERATE,
    CLUSTER_ARTICLE_SEARCH_REQUEST
} from "../actions/action-types"
import {
    clusterListCachedResponse,
    clusterListResponse,
    clusterListErrorResponse,
    clusterListRequest,
    clusterItemResponse,
    clusterItemCachedResponse,
    clusterItemErrorResponse,
    clusterItemRequest,
    clusterItemSaveRequest,
    clusterItemSaveResponse,
    clusterItemDeleteResponse,
    clusterItemDeleteErrorResponse,
    clusterArticleSearchResponse,
    clusterListInvalidationRequest
} from "../actions/cluster-actions"
import { moderationListRequest } from "../actions/moderation-feed-actions"
import { defaultSearchCriteria } from "../reducers/paging/cluster-paging-reducer"
import {
    hydrate as hydrateCluster,
    hydratingFields
} from "../models/entities/cluster"
import {
    getClusterList,
    getClusterItem,
    patchClusterItem,
    postClusterItem,
    deleteClusterItem
} from "../api/cluster-api"
import {
    requestListEpic,
    requestListSearchEpic,
    requestListFilterEpic,
    requestItemEpic,
    requestItemSaveEpic,
    requestItemDeleteEpic,
    requestTopItemFromListResponseEpic,
    syncIdToURLEpic
} from "./default-epics/default-entity-epics"

export const requestClusterListEpic = requestListEpic(
    CLUSTER_LIST_REQUEST,
    getClusterList,
    "clusters",
    clusterListResponse,
    clusterListCachedResponse,
    clusterListErrorResponse
)

export const requestClusterSearchEpic = requestListSearchEpic(
    CLUSTER_LIST_SEARCH_REQUEST,
    clusterListRequest,
    "clusters"
)

export const requestClusterArticleSearchEpic = (action$, { getState }) =>
    action$
        .ofType(CLUSTER_ARTICLE_SEARCH_REQUEST)
        .debounceTime(500)
        .filter(({ value }) => value)
        .map(({ name, value }) => {
            const { presentation, paging } = getState()
            const propName = `${name}SearchCriteria`
            const serialisedSearchCriteria = presentation.clusters[propName]
            let pagingRequest =
                paging.moderationFeed[serialisedSearchCriteria] || {}
            pagingRequest = {
                ...pagingRequest,
                searchCriteria: new Map({ not_rejected: true, title: value }),
                callbackActionCreator: clusterArticleSearchResponse
            }
            return moderationListRequest(pagingRequest)
        })

export const applyClusterFilterCriteria = requestListFilterEpic(
    CLUSTER_APPLY_FILTER_CRITERIA,
    clusterListRequest,
    "clusters"
)

export const requestClusterItemEpic = requestItemEpic(
    CLUSTER_ITEM_REQUEST,
    getClusterItem,
    "clusters",
    hydrateCluster,
    hydratingFields,
    clusterItemResponse,
    clusterItemCachedResponse,
    clusterItemErrorResponse
)

export const requestClusterCancelModelUpdateEpic = (action$, { getState }) =>
    action$
        .ofType(CLUSTER_CANCEL_MODEL_UPDATE)
        .map(() => getState().presentation.clusters.activeId)
        .filter(id => id)
        .map(clusterItemRequest)

export const requestClusterModerateEpic = (action$, { getState }) =>
    action$.ofType(CLUSTER_MODERATE).map(({ moderation }) => {
        const {
            activeId,
            updateModel,
            imageToUpload
        } = getState().presentation.clusters
        const moderatedUpdateModel = updateModel.set("status", moderation)
        return clusterItemSaveRequest(
            activeId,
            moderatedUpdateModel.toJS(),
            imageToUpload
        )
    })

export const requestClusterApplyModelUpdateEpic = (action$, { getState }) =>
    action$.ofType(CLUSTER_APPLY_MODEL_UPDATE).map(() => {
        const {
            activeId,
            updateModel,
            imageToUpload
        } = getState().presentation.clusters
        let newUpdateModel = activeId
            ? updateModel.set("id", activeId)
            : updateModel
        return clusterItemSaveRequest(
            activeId,
            newUpdateModel.toJS(),
            imageToUpload
        )
    })

export const requestClusterItemSaveEpic = requestItemSaveEpic(
    CLUSTER_ITEM_SAVE_REQUEST,
    patchClusterItem,
    postClusterItem,
    "cluster",
    clusterItemSaveResponse,
    clusterItemErrorResponse
)

export const requestClusterItemAfterSavingEpic = (action$, { getState }) =>
    action$.ofType(CLUSTER_ITEM_SAVE_RESPONSE).mergeMap(({ data }) => {
        const { presentation, paging } = getState()
        const { activeId, searchCriteria } = presentation.clusters
        const clusterId = (data.data && data.data.id) || activeId
        const pagingRequest = paging.clusters[searchCriteria]
        return Observable.of(
            clusterItemRequest(clusterId, true, true),
            clusterListInvalidationRequest(pagingRequest)
        )
    })

export const requestClusterItemDeleteEpic = requestItemDeleteEpic(
    CLUSTER_ITEM_DELETE_REQUEST,
    deleteClusterItem,
    "cluster",
    clusterItemDeleteResponse,
    clusterItemDeleteErrorResponse
)

export const responseClusterItemDeleteEpic = (action$, { getState }) =>
    action$.ofType(CLUSTER_ITEM_DELETE_RESPONSE).map(() => {
        const state = getState()
        const string = state.presentation.clusters.searchCriteria
        const pagingRequest = state.paging.clusters[string]
        return clusterItemRequest(pagingRequest.data[0])
    })

export const responseClusterListEpic = requestTopItemFromListResponseEpic(
    CLUSTER_LIST_RESPONSE,
    clusterItemRequest,
    "clusters",
    "clusters",
    defaultSearchCriteria
)

export const syncClusterIdToURLEpic = syncIdToURLEpic(
    "clusters",
    CLUSTER_ITEM_RESPONSE,
    CLUSTER_ITEM_SAVE_RESPONSE,
    CLUSTER_ITEM_CACHED_RESPONSE
)
